var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8XlargeIcons50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BBDEFB",
    d: "M42,5H6C3.791,5,2,6.791,2,9v30c0,2.209,1.791,4,4,4h36c2.209,0,4-1.791,4-4V9C46,6.791,44.209,5,42,5L42,5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E88E5",
    d: "M6 9H42V39H6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF59D",
    d: "M13,17.5c0,1.938,1.565,3.5,3.498,3.5C18.434,21,20,19.438,20,17.5c0-1.935-1.566-3.5-3.502-3.5C14.565,14,13,15.565,13,17.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3F2FD",
    d: "M24,26c0-2.761,2.236-5,5.002-5C31.765,21,34,23.239,34,26c0,2.762-2.235,5-4.998,5C26.236,31,24,28.762,24,26z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3F2FD",
    d: "M19 27c0-2.21 1.789-4 3.999-4C25.211 23 27 24.79 27 27s-1.789 4-4.001 4C20.789 31 19 29.21 19 27zM26.564 34c-1.956 0 3.942-7 5.898-7C34.414 27 36 28.568 36 30.502S34.414 34 32.463 34C30.507 34 28.924 34 26.564 34z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3F2FD",
    d: "M13.831,30.502c0-1.934,1.585-3.502,3.54-3.502c5.896,0,7.853,7,5.896,7c-2.36,0-3.942,0-5.896,0C15.416,34,13.831,32.436,13.831,30.502z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3F2FD",
    d: "M31.456 34L17.32 34 17.32 29.34 31.456 27.008z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8XlargeIcons50);
export default __webpack_public_path__ + "static/media/icons8-xlarge-icons-50.0c1b2dcf2f3085fb9ae37fb60e17c966.svg";
export { ForwardRef as ReactComponent };